import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ palette, typography }) => {
  const commonButtonStyles = {
    marginBottom: '4px',
    padding: '8px',
    fontWeight: typography.weight.regular,
    color: palette.grey.shade[80],
    '& .MuiButton-startIcon': {
      marginRight: '8px'
    }
  }

  return {
    cardContentType: ({ isConsumer }) => ({
      ...(isConsumer && { color: palette.primary.main })
    }),
    time: ({ isConsumer }) => ({
      ...(isConsumer && { color: palette.grey.shade[80] })
    }),
    profileName: {
      paddingLeft: '8px',
      fontWeight: typography.weight.medium
    },
    navigationButton: {
      ...commonButtonStyles,
      '&:hover': {
        textDecoration: 'none'
      },
      '&.active': {
        backgroundColor: palette.primary.shade[5]
      }
    },
    link: {
      ...commonButtonStyles
    }
  }
})
